const truncate = (inputText, maxLength = 200) => {
    if (inputText) {
        if (inputText.length <= maxLength) {
            return inputText;
        }

        const lastSpaceIndex = inputText.lastIndexOf(' ', maxLength);

        return inputText.substring(0, lastSpaceIndex) + '...';
    }
};

export default truncate;